import { Dialog, Button, Typography, Box } from '@mui/material'
import { DialogTitleWithIconClose } from 'app/views/common-components/DialogTitleWithIconClose'
import { Trans } from '@lingui/macro'

interface ConfirmationDialogProps {
  open: boolean
  onConfirmDialogClose: () => void
  text: string | JSX.Element
  title: string | JSX.Element
  onYesClick: () => void
  yesTitle?: string | JSX.Element
  noTitle?: string | JSX.Element
}

const ConfirmationDialog: React.FC<ConfirmationDialogProps> = ({
  open,
  onConfirmDialogClose,
  text,
  title,
  onYesClick,
  yesTitle,
  noTitle
}) => {
  return (
    <Dialog
      maxWidth='xs'
      fullWidth
      open={open}
      onClose={onConfirmDialogClose}
    >
      <DialogTitleWithIconClose
        handleClose={onConfirmDialogClose}
        disabled={false}
      />
      <Box
        sx={{
          padding: '7px 48px 48px 48px',
          display: 'flex',
          flexDirection: 'column'
        }}
      >
        <Typography variant='body1' sx={{ marginBottom: '32px', fontSize: '24px', lineHeight: '28px', fontWeight: '700', wordBreak: 'break-word' }}>
          {title}
        </Typography>
        <Typography variant='body1' sx={{ marginBottom: '32px', fontSize: '14px', lineHeight: '20px', fontWeight: '400' }}>
          {text}
        </Typography>
        <Button
          variant='contained'
          color='primary'
          onClick={() => {
            onYesClick()
          }}
          sx={{ marginBottom: '16px' }}
        >
          {yesTitle ?? <Trans>Yes</Trans>}
        </Button>
        <Button
          variant='outlined'
          color='primary'
          onClick={() => {
            onConfirmDialogClose()
          }}
        >
          {noTitle ?? <Trans>No</Trans>}
        </Button>
      </Box>
    </Dialog>
  )
}

export default ConfirmationDialog
